import Image from "next/image";
import dynamic from "next/dynamic";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import ImagePattern from "./ImagePattern";
import { getGalleryPatientUrl } from "@/lib/gallery";
import { getReadableImageUrl } from "@/lib/directus";

const Link = dynamic(() => import("@/components/ui/Link"));

interface OtherPatientsCarouselProps {
  patients: {
    id: string;
    photos: {
      directus_files_id: {
        id: string;
        filename_download: string;
      };
    };
  }[];
  procedureSlug: string;
}

export default function OtherPatientsCarousel({
  patients,
  procedureSlug,
}: OtherPatientsCarouselProps) {
  return (
    <div className="relative w-full h-auto my-8 select-none">
      <Carousel
        opts={{
          align: "start",
        }}
        className="w-full"
      >
        <CarouselContent>
          {patients.map((patient, index) => (
            <CarouselItem
              key={index}
              className=" md:basis-1/3 xl:basis-1/4 pl-4"
            >
              <Link
                href={`${getGalleryPatientUrl(procedureSlug, patient.id) || "#"}#patient`}
                className="px-4 pt-4 pb-2 bg-zinc-100 hover:bg-orange-200/20 rounded cursor-pointer transition-colors block"
              >
                <div className="relative rounded overflow-hidden">
                  <Image
                    src={getReadableImageUrl(
                      patient.photos[0].directus_files_id.id,
                      patient.photos[0].directus_files_id.filename_disk
                    )}
                    alt={`Image ${index + 1}`}
                    width={300}
                    height={300}
                    className="object-cover w-full"
                    quality={95}
                    loading={"lazy"}
                  />
                </div>
                <div className="flex justify-between mt-1">
                  <span className="text-blue-950 text-sm font-medium font-greycliff">BEFORE</span>
                  <span className="text-blue-950 text-sm font-medium font-greycliff">AFTER</span>
                </div>
              </Link>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="left-2" />
        <CarouselNext className="right-2" />
      </Carousel>
    </div>
  );
}
